
/// actions
export const SUCCESS = '_SUCCESS';
export const REQUEST = '_REQUEST';
export const FAILURE = '_FAILURE';

export const ADD_ROOM = 'ADD_ROOM';
export const REMOVE_ROOM = 'REMOVE_ROOM';
export const CHANGE_PAX = 'CHANGE_PAX';
export const CHANGE_START_DATE = 'CHANGE_START_DATE';
export const CHANGE_END_DATE = 'CHANGE_END_DATE';
export const START_ = 'START_';
export const END_ = 'END_';
export const DATES_AVAILABILITY = 'DATES_AVAILABILITY';
export const START_DATES_AVAILABILITY = `${START_}${DATES_AVAILABILITY}`;
export const END_DATES_AVAILABILITY = `${END_}${DATES_AVAILABILITY}`;
export const START_DATES_AVAILABILITY_SUCCESS = `${START_}${DATES_AVAILABILITY}${SUCCESS}`;
export const START_DATES_AVAILABILITY_REQUEST = `${START_}${DATES_AVAILABILITY}${REQUEST}`;
export const START_DATES_AVAILABILITY_FAILURE= `${START_}${DATES_AVAILABILITY}${FAILURE}`;
export const END_DATES_AVAILABILITY_SUCCESS = `${END_}${DATES_AVAILABILITY}${SUCCESS}`;
export const END_DATES_AVAILABILITY_REQUEST = `${END_}${DATES_AVAILABILITY}${REQUEST}`;
export const END_DATES_AVAILABILITY_FAILURE= `${END_}${DATES_AVAILABILITY}${FAILURE}`;
export const CLICK_PREV_MONTH = 'CLICK_PREV_MONTH';
export const CLICK_NEXT_MONTH = 'CLICK_NEXT_MONTH';
export const UPDATE_AVAIL_FROMTODATES = 'UPDATE_AVAIL_FROMTODATES';
export const CLEAR_CALENDAR_DICT = 'CLEAR_CALENDAR_DICT';

export const CHANGE_PROMOCODE = 'CHANGE_PROMOCODE';
export const REGION_HOTEL = 'REGION_HOTEL'; 
export const CHANGE_REGION_HOTEL = 'CHANGE_REGION_HOTEL';
export const REGION_HOTEL_SUCCESS = `${REGION_HOTEL}${SUCCESS}`;
export const REGION_HOTEL_REQUEST = `${REGION_HOTEL}${REQUEST}`;
export const REGION_HOTEL_FAILURE= `${REGION_HOTEL}${FAILURE}`;

export const SEND_SUBMIT_SEARCHBOX = 'SEND_SUBMIT_SEARCHBOX';
export const SEND_SUBMIT_SEARCHBOX_REQUEST = `${SEND_SUBMIT_SEARCHBOX}${REQUEST}`;
export const SEND_SUBMIT_SEARCHBOX_SUCCESS = `${SEND_SUBMIT_SEARCHBOX}${SUCCESS}`;
export const SEND_SUBMIT_SEARCHBOX_FAILURE = `${SEND_SUBMIT_SEARCHBOX}${FAILURE}`;
export const VALIDATE_SEARCHBOX = 'VALIDATE_SEARCHBOX'; 

export const GET_CONFIG = 'GET_CONFIG';
export const GET_CONFIG_SUCCESS = `${GET_CONFIG}${SUCCESS}`;
export const GET_CONFIG_REQUEST = `${GET_CONFIG}${REQUEST}`;
export const GET_CONFIG_FAILURE = `${GET_CONFIG}${FAILURE}`;


export const DATES_MOMENT_FORMAT = 'YYYY-MM-DD';
export const SEARCH_RESULTS_DATE_MOMENT_FORMAT = 'DD.MM.YYYY';

/// defaults
export const defaultPac ={
    Adults:2, Children:0, Infants:0
};
export const DIV_ID = 'sbox';
export const REQ_DAYS_FORWARD = 180;
export const CHK_OUT_AVAIL_MONS = 1;
export const NEXT_MON_CLICK_MONS = 2;
export const MON_FORWARD_BACK = 3;
export const DEFAULT_LANG = 'eng';
export const NUM_ROOMS = 4;
export const NUM_ADULTS = 4;
export const NUM_CHILDREN = 3;
export const NUM_INFANTS = 3;

/// region hotel city enum
export const HotelRegionType={
    Hotel: 0,
    City: 1,
    Region: 2
}




// WEBPACK FOOTER //
// ./src/tools/constants.js